/**
 * Sales API
 *
 * @author minkyoung.park@emcast.com
 */
import httpService from "@/api/httpService";

const eventApi = {
  // 제품 주문(set goods order)
  // https://clpapi.tinkeredu.co.kr/static/docs/sales.html#resources-sales-order-goods
  boardInfo(params) {
    return httpService.get(`/board/info/${params.boardName}`);
  },
  fetchStaticList(boardId) {
    return httpService.get(`/board/${boardId.toUpperCase()}/article/fix/list`);
  },

  boardAuth(boardId) {
    return httpService.get(`/board/${boardId}/auth`);
  },

  fetchList(params, boardId) {
    console.log("boardId", boardId.toUpperCase())
    return httpService.get(`/board/${boardId.toUpperCase()}/article`, params);
    // return httpService.get(`/board/SNS/article/list`,params)
  },
  getEventDetails(params) {
    return httpService.get(`/board/${params.board}/article/${params.eventId}`)
  },
};
export default eventApi;